import { defineComponent as _defineComponent } from 'vue'
import { inject } from "vue";
import PostPermissionUtil from "@/modules/utils/postPermissionUtil";
import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";
import { ReplyPostStore, isValidReplyPostStoreKey } from "@/store/communityTalk/replyPostStore";

interface Props {
	/**
	 * ニックネーム。
	 */
	nickName: string;
	/**
	 * リプライ内容。
	 */
	contents: string;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    nickName: { type: String, required: true },
    contents: { type: String, required: true },
    communityTalkStoreKey: { type: String, required: true },
    replyPostStoreKey: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * ニックネーム。
	 */
	nickName: string;
	/**
	 * リプライ内容。
	 */
	contents: string;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}
/**
 * リプライ返信ボタン。
 */



// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey) && !isValidReplyPostStoreKey(props.replyPostStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}、${props.replyPostStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;
const replyPostStore = inject(props.replyPostStoreKey) as ReplyPostStore;

const wordSettings = communityTalkStore.getWordSettings();

/**
 * 表示するかどうか。
 */
const isVisible = PostPermissionUtil.isFormVisible(
	communityTalkStore.getGeneralSettings().replyPostPermissionSetting,
	communityTalkStore.getGeneralSettings().replyPostPermissionSpecificECMemberIds,
	communityTalkStore.getSiteUserId()
);

/**
 * 投稿内容に含めるリプライ引用内容: ニックネーム。
 * 例: ニックネームが`ReviCo太郎`の場合:
 * `@ReviCo太郎 さん`
 */
const quoteNickName = (): string => {
	// ニックネームがない場合、空文字(引用内容は何もない)
	if (!props.nickName) {
		return "";
	}
	return `@${props.nickName} さん`;
};

/**
 * 投稿内容に含めるリプライ引用内容: 投稿内容。
 * 例: 投稿内容が`こんにちは[改行]今日はどうですか`の場合:
 * ```
 * > こんにちは
 * > 今日はどうですか
 * ```
 */
const quoteContents = (): string => {
	return `> ${props.contents.replaceAll("\n", "\n> ")}`;
};

const onClick = (): void => {
	// 投稿内容にクリック元のリプライ内容を含める
	let presetContents = `${quoteNickName()}\n${quoteContents()}\n`;
	presetContents = new DOMParser().parseFromString(presetContents, "text/html").documentElement.textContent as string;

	// リプライ投稿フォームを開き、内容をプリセット
	replyPostStore.setPresetContents(presetContents);
	replyPostStore.setIsDisplayReplyPostArea(true);
	replyPostStore.setIsClickReplyResponse(true);
};

const __returned__ = { props, communityTalkStore, replyPostStore, wordSettings, isVisible, quoteNickName, quoteContents, onClick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})